module.exports = __webpack_public_path__ + "files/0f2ae4f53e1dc799515dcab5c7cbc455.png";